import Audi from "../assets/brands/audi-logo-2016-download.png";
import AlfaRomeo from "../assets/brands/Alfa-Romeo-logo-2015-1920x1080.png";
import BMW from "../assets/brands/bmw-logo-2020-gray-download.png";
import Ford from "../assets/brands/ford-logo-2017-download.png";
import Honda from "../assets/brands/honda-logo-2000-full-black-download.png";
import Hyundai from "../assets/brands/hyundai-logo-2011-download.png";
import Kia from "../assets/brands/Kia-logo-2560x1440.png";
import Mazda from "../assets/brands/mazda-logo-2018-vertical-download.png";
import Mercedes from "../assets/brands/Mercedes-Benz-logo-2011-1920x1080.png";
import Nissan from "../assets/brands/nissan-logo-2020-black.png";
import Porsche from "../assets/brands/porsche-logo-2014-full-download.png";
import Subaru from "../assets/brands/subaru-logo-2019-download.png";
import Tesla from "../assets/brands/tesla-logo-2007-black-download.png";
import Toyota from "../assets/brands/toyota-logo-2020-europe-download.png";
import Volkswagen from "../assets/brands/Volkswagen-logo-2019-1500x1500.png";
import Citroen from "../assets/brands/Citroen-logo-2009-2048x2048.png";
import Vauxhall from "../assets/brands/Vauxhall-logo-2008-red-2560x1440.png";
import Volvo from "../assets/brands/Volvo-logo-2014-1920x1080.png";
import Chevrolet from "../assets/brands/Chevrolet-logo-2013-2560x1440.png";
import Peugeot from "../assets/brands/Peugeot-logo-2010-1920x1080.png";

export const LOGO_URL_MAP = {
  Audi: Audi,
  "Alfa-Romeo": AlfaRomeo,
  BMW: BMW,
  Citroen: Citroen,
  Chevrolet: Chevrolet,
  Ford: Ford,
  Honda: Honda,
  Hyundai: Hyundai,
  Kia: Kia,
  Mazda: Mazda,
  "Mercedes-Benz": Mercedes,
  Nissan: Nissan,
  Porsche: Porsche,
  Subaru: Subaru,
  Tesla: Tesla,
  Toyota: Toyota,
  Volkswagen: Volkswagen,
  Vauxhall: Vauxhall,
  Volvo: Volvo,
  Peugeot: Peugeot,
};
